<template>
  <div class="flex_vh100 mallList">
    <van-pull-refresh
      v-model="table_refreshing"
      @refresh="refreshList()"
      :disabled="table_pullDisable"
      class="vh100 ovh"
    >
      <div class="scroll-list" @scroll="onScroll">
        <div v-if="table_list.length > 0">
          <van-list>
            <van-cell v-for="(item, idx) in table_list" :key="idx">
              <div class="flex flex-a-c" @click="toPay(item)">
                <div class="mrgr20">
                  <van-image
                    width="2rem"
                    height="2rem"
                    fit="cover"
                    :src="getImageSrc(item.commodityInfo.img_name)"
                    class="rounded-image"
                  />
                </div>
                <div
                  class="flex flex-column space_between"
                  style="height: 2rem"
                >
                  <div class="size16 fontWgt">
                    <span>{{ item.commodityInfo.name }}</span>
                  </div>
                  <div>
                    <span class="red fontWgt size16"
                      >￥{{
                        calGoodsDistinct(
                          item.commodityInfo,
                          item.lstDiscountInfo
                        )
                      }}</span
                    >
                    <span
                      v-if="
                        calGoodsDistinct(
                          item.commodityInfo,
                          item.lstDiscountInfo
                        ) != (item.commodityInfo.price / 100).toFixed(2)
                      "
                      style="
                        text-decoration: line-through;
                        margin-left: 8px;
                        color: #999;
                      "
                    >
                      ¥{{ (item.commodityInfo.price / 100).toFixed(2) }}
                    </span>
                  </div>
                </div>
              </div>
            </van-cell>
          </van-list>
        </div>
        <div v-else class="empty-state">
          <div class="empty-text">暂无记录</div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>


<script>
import { GetMallGoodsInfo } from "../../api/mallapi.js";
export default {
  props: ["tabindex", "activetab", "categoryId"],
  data() {
    return {
      table_refreshing: false,
      table_pullDisable: false,
      table_list: [],

      isActive: false,
    };
  },
  methods: {
    //刷新数据
    refreshList() {
      this.table_refreshing = true;
      this._getMallGoodsInfo().finally((val) => {
        this.table_refreshing = false;
      });
    },

    onScroll(e) {
      if (e.target.scrollTop != 0) {
        this.table_pullDisable = true;
      } else {
        this.table_pullDisable = false;
      }
    },

    // 安全获取图片路径
    getImageSrc(path) {
      try {
        return require(`@/assets/images_app/${path}.png`);
      } catch (e) {
        return require("@/assets/images/bgcenter.png");
      }
    },

    //计算折扣
    calGoodsDistinct(commodityInfo, lstDiscountInfo) {
      var disPrice = commodityInfo.price;
      lstDiscountInfo.forEach((e) => {
        //百分比
        if (e.d_type == 1) {
          disPrice = disPrice * (e.d_value / 10000);
        }
        //直减
        if (e.d_type == 2) {
          disPrice = disPrice - e.d_value;
        }
      });
      return (disPrice / 100).toFixed(2);
    },

    toPay(goodsInfo) {
      this.$router.push({
        name: "Order",
        query: {
          commodityId: goodsInfo.commodityInfo.commodityId,
        },
      });
    },

    //读取商城商品列表
    _getMallGoodsInfo() {
      var par = {
        categoryId: this.categoryId,
      };
      return GetMallGoodsInfo(par).then((res) => {
        this.table_list = res;
        this.isActive = true;
      });
    },
  },
  mounted() {
    if (!this.isActive) {
      //刷新列表
      this._getMallGoodsInfo();
    }
  },
};
</script>

<style scoped>
/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
  height: 100%;
}
.empty-text {
  font-size: 14px;
  margin-bottom: 16px;
}
/* 可滚动列表 */
.scroll-list {
  flex: 1;
  overflow-y: auto;
  height: 100%;
}
.scroll-list::-webkit-scrollbar {
  width: 4px;
}
.scroll-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}
.scroll-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}
.scroll-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>

<style>
.mallList .tab_content {
  padding: 0;
}
</style>